import { IHoliday } from "../holidayTypes";

export const UsaHolidays: { [key: string]: IHoliday } = {
  // 2024
  "2024-01-01": { title: "New Year's Day", type: "HOLIDAY" },
  "2024-01-15": { title: "Martin Luther King Jr. Day", type: "HOLIDAY" },
  "2024-02-02": { title: "Groundhog Day", type: "SPECIAL_DAY" },
  "2024-02-14": { title: "Valentine's Day", type: "SPECIAL_DAY" },
  "2024-02-19": { title: "Presidents' Day", type: "HOLIDAY" },
  "2024-03-17": { title: "St. Patrick's Day", type: "SPECIAL_DAY" },
  "2024-03-31": { title: "Easter Sunday", type: "SPECIAL_DAY" },
  "2024-05-12": { title: "Mother's Day", type: "SPECIAL_DAY" },
  "2024-05-27": { title: "Memorial Day", type: "HOLIDAY" },
  "2024-06-16": { title: "Father's Day", type: "SPECIAL_DAY" },
  "2024-07-04": { title: "Independence Day", type: "HOLIDAY" },
  "2024-09-02": { title: "Labor Day", type: "HOLIDAY" },
  "2024-10-14": { title: "Columbus Day", type: "HOLIDAY" },
  "2024-10-31": { title: "Halloween", type: "SPECIAL_DAY" },
  "2024-11-05": { title: "Election Day", type: "SPECIAL_DAY" },
  "2024-11-11": { title: "Veterans Day", type: "HOLIDAY" },
  "2024-11-28": { title: "Thanksgiving Day", type: "HOLIDAY" },
  "2024-12-24": { title: "Christmas Eve", type: "SPECIAL_DAY" },
  "2024-12-25": { title: "Christmas Day", type: "HOLIDAY" },
  "2024-12-26": { title: "Boxing Day", type: "HOLIDAY" },
  "2024-12-31": { title: "New Year's Eve", type: "SPECIAL_DAY" },

  // 2025
  "2025-01-01": { title: "New Year's Day", type: "HOLIDAY" },
  "2025-01-20": { title: "Martin Luther King Jr. Day", type: "HOLIDAY" },
  "2025-02-17": { title: "Presidents' Day", type: "HOLIDAY" },
  "2025-02-02": { title: "Groundhog Day", type: "SPECIAL_DAY" },
  "2025-02-14": { title: "Valentine's Day", type: "SPECIAL_DAY" },
  "2025-03-17": { title: "St. Patrick's Day", type: "SPECIAL_DAY" },
  "2025-04-20": { title: "Easter Sunday", type: "SPECIAL_DAY" },
  "2025-05-11": { title: "Mother's Day", type: "SPECIAL_DAY" },
  "2025-05-26": { title: "Memorial Day", type: "HOLIDAY" },
  "2025-06-15": { title: "Father's Day", type: "SPECIAL_DAY" },
  "2025-06-19": { title: "Juneteenth National Independence Day", type: "HOLIDAY" },
  "2025-07-04": { title: "Independence Day", type: "HOLIDAY" },
  "2025-09-01": { title: "Labor Day", type: "HOLIDAY" },
  "2025-10-13": { title: "Columbus Day", type: "HOLIDAY" },
  "2025-10-31": { title: "Halloween", type: "SPECIAL_DAY" },
  "2025-11-04": { title: "Election Day", type: "SPECIAL_DAY" },
  "2025-11-11": { title: "Veterans Day", type: "HOLIDAY" },
  "2025-11-27": { title: "Thanksgiving Day", type: "HOLIDAY" },
  "2025-12-24": { title: "Christmas Eve", type: "SPECIAL_DAY" },
  "2025-12-25": { title: "Christmas Day", type: "HOLIDAY" },
  "2025-12-26": { title: "Boxing Day", type: "HOLIDAY" },
  "2025-12-31": { title: "New Year's Eve", type: "SPECIAL_DAY" },

  // 2026
  "2026-01-01": { title: "New Year's Day", type: "HOLIDAY" },
  "2026-01-19": { title: "Martin Luther King Jr. Day", type: "HOLIDAY" },
  "2026-02-02": { title: "Groundhog Day", type: "SPECIAL_DAY" },
  "2026-02-14": { title: "Valentine's Day", type: "SPECIAL_DAY" },
  "2026-02-16": { title: "Washington's Birthday (Presidents' Day)", type: "HOLIDAY" },
  "2026-03-17": { title: "St. Patrick's Day", type: "SPECIAL_DAY" },
  "2026-04-05": { title: "Easter Sunday", type: "SPECIAL_DAY" },
  "2026-05-10": { title: "Mother's Day", type: "SPECIAL_DAY" },
  "2026-05-25": { title: "Memorial Day", type: "HOLIDAY" },
  "2026-06-19": { title: "Juneteenth National Independence Day", type: "HOLIDAY" },
  "2026-06-21": { title: "Father's Day", type: "SPECIAL_DAY" },
  "2026-07-04": { title: "Independence Day", type: "HOLIDAY" },
  "2026-09-07": { title: "Labor Day", type: "HOLIDAY" },
  "2026-10-12": { title: "Columbus Day", type: "HOLIDAY" },
  "2026-10-31": { title: "Halloween", type: "SPECIAL_DAY" },
  "2026-11-03": { title: "Election Day", type: "SPECIAL_DAY" },
  "2026-11-11": { title: "Veterans Day", type: "HOLIDAY" },
  "2026-11-26": { title: "Thanksgiving Day", type: "HOLIDAY" },
  "2026-12-24": { title: "Christmas Eve", type: "SPECIAL_DAY" },
  "2026-12-25": { title: "Christmas Day", type: "HOLIDAY" },
  "2026-12-26": { title: "Boxing Day", type: "HOLIDAY" },
  "2026-12-31": { title: "New Year's Eve", type: "SPECIAL_DAY" },

  // 2027
  "2027-01-01": { title: "New Year's Day", type: "HOLIDAY" },
  "2027-01-18": { title: "Martin Luther King Jr. Day", type: "HOLIDAY" },
  "2027-02-02": { title: "Groundhog Day", type: "SPECIAL_DAY" },
  "2027-02-14": { title: "Valentine's Day", type: "SPECIAL_DAY" },
  "2027-02-15": { title: "Washington's Birthday (Presidents' Day)", type: "HOLIDAY" },
  "2027-03-17": { title: "St. Patrick's Day", type: "SPECIAL_DAY" },
  "2027-03-28": { title: "Easter Sunday", type: "SPECIAL_DAY" },
  "2027-05-09": { title: "Mother's Day", type: "SPECIAL_DAY" },
  "2027-05-31": { title: "Memorial Day", type: "HOLIDAY" },
  "2027-06-19": { title: "Juneteenth National Independence Day", type: "HOLIDAY" },
  "2027-06-20": { title: "Father's Day", type: "SPECIAL_DAY" },
  "2027-07-04": { title: "Independence Day", type: "HOLIDAY" },
  "2027-09-06": { title: "Labor Day", type: "HOLIDAY" },
  "2027-10-11": { title: "Columbus Day", type: "HOLIDAY" },
  "2027-10-31": { title: "Halloween", type: "SPECIAL_DAY" },
  "2027-11-02": { title: "Election Day", type: "SPECIAL_DAY" },
  "2027-11-11": { title: "Veterans Day", type: "HOLIDAY" },
  "2027-11-25": { title: "Thanksgiving Day", type: "HOLIDAY" },
  "2027-12-24": { title: "Christmas Eve", type: "SPECIAL_DAY" },
  "2027-12-25": { title: "Christmas Day", type: "HOLIDAY" },
  "2027-12-26": { title: "Boxing Day", type: "HOLIDAY" },
  "2027-12-31": { title: "New Year's Eve", type: "SPECIAL_DAY" }
};



// WEBPACK FOOTER //
// ./src/constants/holidays/usa/usaHolidays.ts